import { getCurrentUserId } from '../../publicSession/selectors';
export function canUserVoteInPoll(state, { poll }) {
    if (!poll || poll.hasVoted) {
        return false;
    }
    // we don't allow the poll owner to vote
    const currentUserId = getCurrentUserId(state);
    if (currentUserId === poll.user.userId) {
        return false;
    }
    return true;
}
